/**
 * 14px by default, because that is the size `<Button>`'s loading state swaps its
 * label for while holding the button's width fixed (components.md §3).
 *
 * It is never used in a data panel. Those get skeletons that match the real row
 * geometry — a centred spinner over a table is the layout shift skeletons exist
 * to prevent.
 */

import { cx } from '@/lib/cx'

export interface SpinnerProps {
  size?: number
  className?: string
  label?: string
}

export function Spinner({ size = 14, className, label = 'loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx('inline-block shrink-0 animate-spin rounded-full', className)}
      style={{
        // Design pixels, through the scale unit like every other size.
        width: `calc(${size} * var(--ud-u))`,
        height: `calc(${size} * var(--ud-u))`,
        borderWidth: size >= 20 ? 2 : 1.5,
        borderStyle: 'solid',
        borderColor: 'currentColor',
        borderTopColor: 'transparent',
        animationDuration: '600ms',
      }}
    />
  )
}
